import CodingEntityDropdown from 'app/pages/overview/tabs/transactions/CodingEntityDropdown';
import { AgaveGlCode, HighnoteTransactionEvent } from 'API';

interface AgaveGlCodesDropdownProps {
  disabled?: boolean;
  disableHeader?: boolean;
  selectedCode?: AgaveGlCode | null;
  onValueChange: (option: AgaveGlCode | null) => void;
  transaction?: HighnoteTransactionEvent;
  placeholder?: string | null;
  enabled?: boolean;
}

const AgaveGlCodesDropdown = ({
  disabled,
  disableHeader = true,
  selectedCode,
  onValueChange,
  transaction,
  placeholder,
  enabled = true,
}: AgaveGlCodesDropdownProps) => {
  return (
    <CodingEntityDropdown<AgaveGlCode>
      entityType="glCodes"
      selectedItem={selectedCode}
      onValueChange={onValueChange}
      disabled={disabled}
      disableHeader={disableHeader}
      placeholder={placeholder || undefined}
      identifierField="number"
      cardGroupId={transaction?.cardGroupId || undefined}
      enabled={enabled}
    />
  );
};

export default AgaveGlCodesDropdown;
